<script setup lang="ts">
import type { BaseIconName } from '@/js/account/components/base/BaseIcon.vue';
import BaseButton from '@/js/account/components/base/BaseButton.vue';
import BaseIcon from '@/js/account/components/base/BaseIcon.vue';
import { classNames } from '@/js/lib/bem';

defineProps<{
  icon: BaseIconName
  title: string
  description: string
  buttonLabel: string
}>();

const emit = defineEmits<{
  action: []
}>();

const cn = classNames('dashboard-quick-action');
</script>

<template>
  <div :class="cn()">
    <BaseIcon :name="icon" :class="cn('icon')" :width="32" :height="32" />
    <h3 :class="cn('title')">
      {{ title }}
    </h3>
    <p :class="cn('description')">
      {{ description }}
    </p>
    <BaseButton
      :class="cn('button')"
      size="sm"
      theme="primary"
      @click="emit('action')"
    >
      {{ buttonLabel }}
    </BaseButton>
  </div>
</template>

<style lang="scss" scoped>
.dashboard-quick-action {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-radius: 4px;
  background-color: var(--color-white);
  box-shadow: var(--shadow);

  &__icon {
    color: var(--color-primary);
    flex-shrink: 0;
    margin: 0 0 16px;
  }

  &__title {
    font-size: 24px;
    line-height: 1.2;
    color: var(--color-text-primary);
    font-family: var(--font-family-serif);
    margin: 0 0 8px;
    font-weight: 400;
  }

  &__description {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.2;
    color: var(--color-text-secondary);
    margin: 0 0 16px;
    flex: 1;
  }
}
</style>
